module.exports = __webpack_public_path__ + "static/media/Empty_area.262552f3.svg";